import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        marginBottom: '70px'
    },
    text: {
        fontWeight: 'bold',
        marginBottom: '20px'
    },
    submit: {
        height: 54,
    },
    input: {
        height: 54,
    }
}));

export default useStyles;